import { Money } from "./money.model";

export class Price {
	public storageId: number
	public money: Money
	public vat: number
}



// WEBPACK FOOTER //
// ./src/app/models/price.model.ts